import "./mvp-hero.scss";
